import React from 'react'

import gambleSuitButtonBlackTexture from '@assets/button-gambleblack-small-enabled.png?inline'
import gambleSuitButtonRedTexture from '@assets/button-gamblered-small-enabled.png?inline'

import gambleSuitButtonBlackTextureEQ from '@assets/jackpot-eq/button-gambleblack-small-enabled-eq.png?inline'
import gambleSuitButtonRedTextureEQ from '@assets/jackpot-eq/button-gamblered-small-enabled-eq.png?inline'

import { SideButton } from '../'
import { RedGambleClickedMessage, GameUIMessageType, BlackGambleClickedMessage } from 'game-ui-types'
import styles from '../SpinButtonSection.module.css'
import { useJackpotStore } from '@stores'

type SuitColor = 'red' | 'black'

interface GambleSuitButtonProps {
    isActive: boolean
    suitColor: SuitColor
    shouldUpdateOpacityWhenInactive?: boolean
    disableAutoBlur?: boolean
}

const GambleSuitButton: React.FC<GambleSuitButtonProps> = ({
    isActive,
    suitColor,
    shouldUpdateOpacityWhenInactive,
    disableAutoBlur,
}) => {
    const isEQJackpotType = useJackpotStore((state) => state.isEQJackpotType)

    const handleClick = () => {
        if (suitColor === 'red') {
            const redGambleClickedMessage: RedGambleClickedMessage = { type: GameUIMessageType.RED_GAMBLE_CLICKED }

            window.uiBus.postMessage(redGambleClickedMessage)
        }

        if (suitColor === 'black') {
            const blackGambleClickedMessage: BlackGambleClickedMessage = {
                type: GameUIMessageType.BLACK_GAMBLE_CLICKED,
            }

            window.uiBus.postMessage(blackGambleClickedMessage)
        }
    }

    const gambleRedButton = !isEQJackpotType ? gambleSuitButtonRedTexture : gambleSuitButtonRedTextureEQ
    const gambleBlackButton = !isEQJackpotType ? gambleSuitButtonBlackTexture : gambleSuitButtonBlackTextureEQ

    return (
        <SideButton
            id={`gamble-${suitColor}`}
            isActive={isActive}
            onClick={handleClick}
            texture={suitColor === 'red' ? gambleRedButton : gambleBlackButton}
            shouldUpdateOpacityWhenInactive={shouldUpdateOpacityWhenInactive}
            disableAutoBlur={disableAutoBlur}
            className={styles.clipCircle}
        />
    )
}

export default GambleSuitButton
